import React, { useEffect } from 'react';
import styles from '@/styles/Headline.module.scss';
import { PEIHeadLine } from '@/common/components/PEIHeadline';
import { HeadLineItems } from './headlineItem';
import { URL } from '@/utils';
import { PEIRecordsInfo, PEISectionFooter, defaultImagePath } from '@/common';
import { useAppContext } from '@/components';
import { getCTAS } from '@/utils';

const { basePEIURL } = URL;

type headlineItemsProp = {
  image: string;
  title: string;
  summary: string;
  type: string;
  postName: string;
  thumbnail: string;
};

type headlineProp = {
  institutionID: string;
  institutionName: string;
  userType: string;
  partnerStatus: string;
  headlineItems?: headlineItemsProp[];
  total?: number;
};

export const Headlines = ({
  headlineItems,
  partnerStatus,
  total,
  institutionName,
  userType,
  institutionID,
}: headlineProp) => {
  const { dispatch } = useAppContext();

  useEffect(() => {
    dispatch({
      type: 'setRecordInfo',
      payload: {
        key: 'headlines',
        value: headlineItems && headlineItems.length > 0,
      },
    });
  }, [dispatch, headlineItems]);

  const allData = getCTAS(userType, institutionName, institutionID);
  const headlinesComponentData: {
    ctaHeading?: string;
    LP: string;
    GP: string;
    'LP/GP': string;
  } = allData['HeadlinesComponent'];

  const ctas = {
    ctaButton: '',
  };

  switch (partnerStatus) {
    case 'LP':
      ctas.ctaButton = headlinesComponentData.LP;
      break;
    case 'GP':
      ctas.ctaButton = headlinesComponentData.GP;
      break;
    case 'LP/GP':
      ctas.ctaButton = headlinesComponentData['LP/GP'];
      break;
  }

  return (
    <React.Fragment>
      <article className={styles.container} id='headlines'>
        <main className={styles['container-body']}>
          <PEIHeadLine text={`${institutionName} related stories`} />
          <div className={styles.galleyContainer}>
            {headlineItems?.map((item, id) => (
              <HeadLineItems
                key={id + 'context'}
                imageURL={item?.thumbnail ? item?.thumbnail : defaultImagePath}
                headingText={item.title}
                contentText={item.summary}
                link={`${basePEIURL}/${item?.postName}`}
              />
            ))}
          </div>
          {/* As per WEB-12501 need to hide */}
          {/* <div className={styles.peiRecordsContainer}>
            <PEIRecordsInfo
              institutionName={institutionName}
              start={headlineItems?.length}
              end={total}
              componentName='headlines'
            />
          </div> */}
        </main>
        <PEISectionFooter textToShow={headlinesComponentData.ctaHeading} link={ctas.ctaButton} />
      </article>
    </React.Fragment>
  );
};
